import { defineMessages } from 'react-intl';

export default defineMessages({
    driverx: {
        id: 'ml.quoteandbind.pa.additionalInformation.Driverx',
        defaultMessage: 'Driver {driverIndex}'
    },
    licenseNumber: {
        id: 'ml.quoteandbind.pa.additionalInformation.Driver\'s License',
        defaultMessage: 'Driver\'s License'
    },
    singlePound: {
        id: 'ml.quoteandbind.pa.additionalInformation.pound',
        defaultMessage: '#'
    },
    driverEmailAddress: {
        id: 'ml.quoteandbind.pa.additionalInformation.Email Address',
        defaultMessage: 'Email Address'
    },
    reenterEmailAddress: {
        id: 'ml.quoteandbind.pa.additionalInformation.Email address required. Please re-enter to confirm',
        defaultMessage: 'Email address required. Please re-enter to confirm'
    },
    requiresProofLabel: {
        id: 'ml.quoteandbind.pa.additionalInformation.Requires proof of financial responsibility (SR22/FR44/FR19/FS1)?',
        defaultMessage: 'Requires proof of financial responsibility (SR22/FR44/FR19/FS1)?'
    },
    requestingStateLabel: {
        id: 'ml.quoteandbind.pa.additionalInformation.Which State is requiring Proof?',
        defaultMessage: 'Which State is requiring Proof?'
    },
    reasonRequired: {
        id: 'ml.quoteandbind.pa.additionalInformation.Reason Required',
        defaultMessage: 'Reason Required'
    },
    caseNumber: {
        id: 'ml.quoteandbind.pa.additionalInformation.Case Number',
        defaultMessage: 'Case Number'
    },
    certificateEffDate: {
        id: 'ml.quoteandbind.pa.additionalInformation.Certificate Effective Date',
        defaultMessage: 'Certificate Effective Date'
    },
    spouseEmailAddress: {
        id: 'ml.quoteandbind.pa.additionalInformation.Spouse\'s Email Address',
        defaultMessage: 'Spouse\'s Email Address'
    },
    requiresProofTooltipTitle: {
        id: 'ml.quoteandbind.pa.additionalInformation.requiresProof.What is this?',
        defaultMessage: 'What is this?'
    },
    requiresProofTooltipContent: {
        id: 'ml.quoteandbind.pa.additionalInformation.requiresProof.SR-22 or FR44 Help Message',
        defaultMessage: 'Proof of Financial Responsibility is a state-mandated document that certifies that the liability insurance purchased meets the minimum required limits of coverage for the state. The certificate (SR22, FR44, FR19 or FS1) is filed with your state\'s Department of Motor Vehicles by your auto insurance carrier. Select this if you have a Proof of Financial Responsibility certification with your current carrier or if your state\'s DMV or a court order requires you to have the certification. MetLife Auto & Home does not charge a fee to file the certificate.'
    },
    gatewayDriverX: {
        id: 'ml.quoteandbind.pa.additionalInformation.(Driver #X)',
        defaultMessage: '(Driver #{driverNumber})'
    },
    gatewayRequiresProofTooltipTitle: {
        id: 'ml.quoteandbind.pa.additionalInformation.requiresProof.What is an SR22/FR44/FR19/FS1?',
        defaultMessage: 'What is an SR22/FR44/FR19/FS1?'
    },
    emailScript: {
        id: 'ml.quoteandbind.pa.additionalInformation.EMAIL SCRIPT',
        defaultMessage: 'EMAIL SCRIPT'
    },
    emailScriptMessage: {
        id: 'ml.quoteandbind.pa.additionalInformation.emailScriptMessage',
        defaultMessage: 'When you provide your email address, you consent to receiving emails about your online quote and other product information from third parties working for us who we gave your email address.  We do not share our customer’s personal information with unaffiliated third parties for their own direct marketing purposes.  To view our complete Privacy Policy, click on the Privacy Policy link on the bottom of the screen.'
    },
    invalidEmail:{
        id:'ml.quoteandbind.pa.additionalInformation.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    }
});
